var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Row, Col } from "@folio/stripes/components";
import { Controller } from "react-hook-form";
import { RecekTextArea, RecekTextField } from "./inputs";
import { PARTIAL_DATE_PLACEHOLDER } from "../utils/dateUtils";
export var NaturalPersonGeneralFields = function (_a) {
    var control = _a.control, _b = _a.layout, layout = _b === void 0 ? "stacked" : _b, _c = _a.biographicalNoteRequired, biographicalNoteRequired = _c === void 0 ? true : _c;
    var halfCol = layout === "compact" ? 6 : 12;
    return (React.createElement(Row, null,
        React.createElement(Col, { xs: halfCol },
            React.createElement(Controller, { control: control, name: "firstName", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.firstName.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                } })),
        React.createElement(Col, { xs: halfCol },
            React.createElement(Controller, { control: control, name: "lastName", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.lastName.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                } })),
        React.createElement(Col, { xs: halfCol },
            React.createElement(Controller, { control: control, name: "birthDate", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.birthDate.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, placeholder: PARTIAL_DATE_PLACEHOLDER })));
                } })),
        React.createElement(Col, { xs: halfCol },
            React.createElement(Controller, { control: control, name: "deathDate", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.natural-person.deathDate.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, placeholder: PARTIAL_DATE_PLACEHOLDER })));
                } })),
        React.createElement(Col, { xs: 12 },
            React.createElement(Controller, { control: control, name: "biographicalNote", render: function (_a) {
                    var _b;
                    var field = _a.field, fieldState = _a.fieldState;
                    return (React.createElement(RecekTextArea, __assign({}, field, { labelId: "ui-br-agency.natural-person.biographicalNote.field.label", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: biographicalNoteRequired, fullWidth: true })));
                } }))));
};
